import { MODULE } from "./notifications.actionTypes";

export const getNotification = (state) => state.getIn([MODULE, "notification"]);
export const getNotificationType = (state) => state.getIn([MODULE, "notificationType"]);
export const getLastNotification = (state) => state.getIn([MODULE, "lastNotification"]);
